/**
 * Classe
 */
export class AuthUser {

    /** ID da entidade no Firebase  */
    uid: string;

    /** Nome do usuário  */
    displayName: string;

    /** E-mail do usuário  */
    email: string;

    /** Token do usuário logado  */
    refreshToken: string;

    /**
     * Instanciar um novo Usuário
     * @param init - JSON que represente parcialmente as propriedades da classe
     */
    public constructor(init?: Partial<AuthUser>) {
        Object.assign(this, init);
    }
}
